import React, { useState, useEffect } from "react";
import logo from "./images/logo.png";
import Nav from "react-bootstrap/Nav";
import "./navbar.css";

const NavigationBar = () => {
  const [isSticky, setIsSticky] = useState(false);

  useEffect(() => {
    let timeoutId = null;

    const handleScroll = () => {
      clearTimeout(timeoutId);
      timeoutId = setTimeout(() => {
        setIsSticky(window.scrollY > 50);
      }, 10); // debounce delay
    };

    window.addEventListener("scroll", handleScroll);
    return () => {
      clearTimeout(timeoutId);
      window.removeEventListener("scroll", handleScroll);
    };
  }, []);

  return (
    <>
      <Nav id="navbar" className={`navbar ${isSticky ? "sticky" : ""}`}>
        <div className="logo">
          <Nav.Link href="/" className="text-light">
            <img src={logo} alt="Logo" width={200} />
          </Nav.Link>
        </div>
        <ul id="menu">
          <li>
            <Nav.Link href="/" className="">
              Home
            </Nav.Link>
          </li>
          <li>
            <Nav.Item>
              <Nav.Link href="/products" className="">
                Products
              </Nav.Link>
            </Nav.Item>
          </li>
          {/* <Nav.Item>
              <Nav.Link href="#blog" className="">
                Blog
              </Nav.Link>
            </Nav.Item> */}
          <li>
            <Nav.Item>
              <Nav.Link href="/services" className="">
                Services
              </Nav.Link>
            </Nav.Item>
          </li>
          <li>
            <Nav.Item>
              <Nav.Link href="/why-us" className="">
                Why Us
              </Nav.Link>
            </Nav.Item>
          </li>
          <li>
            <Nav.Item>
              <Nav.Link href="/contact-us" className="">
                Contact Us
              </Nav.Link>
            </Nav.Item>
          </li>
          {/* <li>
            <Nav.Item>
              <Nav.Link href="/about-us" className="">
                About Us
              </Nav.Link>
            </Nav.Item>
          </li> */}
        </ul>
      </Nav>

      <div className="menuIcon">
        <span className="icon icon-bars"></span>
        <span className="icon icon-bars overlay"></span>
      </div>

      <div className="overlay-menu">
        <ul id="menu">
          <li>
            <a href="/">Home</a>
          </li>
          <li>
            <a href="/products">Products</a>
          </li>
          <li>
            <a href="/services">Services</a>
          </li>
          <li>
            <a href="/why-us">Whu Us</a>
          </li>
          <li>
            <a href="/contact-us">Contact Us</a>
          </li>
        </ul>
      </div>
    </>
  );
};

export default NavigationBar;
